<style lang="less">
.local-main-region-option{
  .ant-cascader-menus{
    .ant-cascader-menu{
      height: 360px !important;
    }
  }
}
.complex-form-horizontal{
  .complex-form-item{
    .complex-form-item-date{
      width: 100%;
    }
  }
}

</style>
<style lang="less" scoped>
@import '@/style/index.less';
</style>
<template>
  <AntdApp>
    <router-view />
    <FloatView />
  </AntdApp>
</template>

<script>
import { defineComponent } from 'vue'
import '@/style/default.less'
import AntdApp from '@/components/data/AntdApp.vue'
import FloatView from './float/FloatView'

export default defineComponent({
  components: {
    AntdApp,
    FloatView
  }
})
</script>
